// FacultyOBEConfig.jsx
import React, { useState } from 'react';
import CourseOutcome from '../Admin/OBE/CourseOutcome';
import CoPoMapping from '../Admin/OBE/CoPoMapping';
import { FiBook, FiLink, FiSettings, FiCpu } from 'react-icons/fi';

const FacultyOBEConfig = () => {
  const [activeTab, setActiveTab] = useState('course-outcomes');

  const tabs = [
    { 
      id: 'course-outcomes', 
      label: 'Course Outcomes', 
      icon: <FiBook className="w-4 h-4" />,
      description: 'Define and manage Course Outcomes for subjects. Automatic CO-PO mapping is applied on save.'
    },
    { 
      id: 'co-po-mapping', 
      label: 'CO-PO Mapping', 
      icon: <FiLink className="w-4 h-4" />,
      description: 'View auto-mapped matrix and customize/edit CO-PO mapping strengths'
    },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'course-outcomes':
        return <CourseOutcome />;
      case 'co-po-mapping':
        return <CoPoMapping />;
      default:
        return <CourseOutcome />;
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bento-header-banner flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="p-2.5 bg-indigo-50 dark:bg-indigo-950/60 text-indigo-600 dark:text-indigo-400 border border-indigo-100 dark:border-indigo-800 rounded-xl">
            <FiSettings className="text-xl" />
          </div>
          <div>
            <h1 className="text-xl font-bold tracking-tight text-slate-900 dark:text-white">Faculty OBE & CO-PO Mapping</h1>
            <p className="text-slate-500 dark:text-slate-400 text-xs mt-0.5">
              Manage Course Outcomes with Automatic & Editable CO-PO Mapping
            </p>
          </div>
        </div>
        <div className="hidden sm:flex items-center space-x-2 px-3 py-1.5 bg-emerald-50 dark:bg-emerald-950/60 text-emerald-700 dark:text-emerald-300 rounded-xl text-xs font-bold border border-emerald-200 dark:border-emerald-800">
          <FiCpu className="text-emerald-600 dark:text-emerald-400 text-sm" />
          <span>Auto-Mapping Active</span>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-xs border border-slate-200 dark:border-slate-800 overflow-hidden">
        <div className="flex border-b border-slate-200 dark:border-slate-800 p-2 gap-2 bg-slate-50 dark:bg-slate-950">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`flex-1 px-4 py-2.5 rounded-xl text-center text-xs font-bold transition-all cursor-pointer ${
                activeTab === tab.id 
                  ? 'bg-white dark:bg-slate-900 text-indigo-600 dark:text-indigo-400 shadow-xs border border-slate-200/60 dark:border-slate-800'
                  : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-slate-100 dark:hover:bg-slate-900'
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              <div className="flex items-center justify-center space-x-2">
                {tab.icon}
                <span>{tab.label}</span>
              </div>
            </button>
          ))}
        </div>
        
        {/* Tab Description */}
        <div className="p-3.5 bg-indigo-50/40 dark:bg-slate-950/50 border-b border-slate-200 dark:border-slate-800">
          <div className="flex items-center space-x-2 text-xs text-slate-600 dark:text-slate-400">
            {tabs.find(tab => tab.id === activeTab)?.icon}
            <span className="font-bold text-slate-800 dark:text-slate-200">
              {tabs.find(tab => tab.id === activeTab)?.label}:
            </span>
            <span>
              {tabs.find(tab => tab.id === activeTab)?.description}
            </span>
          </div>
        </div>

        {/* Tab Content */}
        <div className="p-6">
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
};

export default FacultyOBEConfig;
